exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".route-heading[data-v-1bfdb739] {\n  padding: 0px 10px;\n}\n.tree[data-v-1bfdb739] {\n  padding: 5px;\n}\n", ""]);

// exports
